<script>
    export let msg = '';
</script>
<div class="h-100 w-100 d-flex align-items-center justify-content-center" style="font-size: 13px;">
    <span class="text-secondary" style="text-align: center; width: 100%;">{msg}</span>
</div>